export const dateDifferenceCalculator = function (date, periodInHours) {
    const difference = periodInHours * 3600000;
    return new Date(date.getTime() - difference);
};
//# sourceMappingURL=dateDifferenceCalculator.js.map